import { render, staticRenderFns } from "./CamSettingStudentDialog.vue?vue&type=template&id=2b18d8f8&scoped=true"
import script from "./CamSettingStudentDialog.vue?vue&type=script&lang=js"
export * from "./CamSettingStudentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18d8f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b18d8f8')) {
      api.createRecord('2b18d8f8', component.options)
    } else {
      api.reload('2b18d8f8', component.options)
    }
    module.hot.accept("./CamSettingStudentDialog.vue?vue&type=template&id=2b18d8f8&scoped=true", function () {
      api.rerender('2b18d8f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/CamSettingStudentDialog.vue"
export default component.exports